export default __webpack_public_path__ + "static/media/age.8c6d2764.png";